(() => {
  function enhance(root = document) {
    root.querySelectorAll('.sa-article .blog-post-content').forEach(content => {
      content.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('sa-article__table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'sa-article__table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent || 'Article comparison table');
        table.before(wrapper);
        wrapper.append(table);
      });
      const headings = [...content.querySelectorAll('rte-formatter > h2')];
      const heading = headings.at(-1);
      const paragraph = heading?.nextElementSibling;
      if (!heading || paragraph?.tagName !== 'P' || heading.closest('.sa-article__cta')) return;
      const shopLink = [...paragraph.querySelectorAll('a[href]')].find(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        return url.origin === location.origin && /^\/(collections|products)\//.test(url.pathname);
      });
      if (!shopLink) return;
      const card = document.createElement('div');
      card.className = 'sa-article__cta';
      heading.before(card);
      card.append(heading, paragraph);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
